export default function isEmailAtSpendesk(email: string): boolean {
  return email.endsWith('@spendesk.com');
}
